<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="600px" @keydown="checkEsc">
      <v-card>
        <v-card-title>
          <span class="headline">{{ dialogData.dialogMessage }}</span>
          <h5
            @click="showDoc"
            :class="{ 'documet-link': dialogData.previousDocument }"
          >
            {{ dialogData.dialogDescription }}
          </h5>
        </v-card-title>
        <v-card-text> </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="cancel">{{ $t('global.close') }}</v-btn>
          <v-btn
            flat
            v-if="!(dialogData.textAction1 == '')"
            @click="confirmAction1"
            >{{ dialogData.textAction1 }}</v-btn
          >
          <v-btn
            flat
            v-if="!(dialogData.textAction2 == '')"
            @click="confirmAction2"
            >{{ dialogData.textAction2 }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import router from '@/router'
import i18n from '@/plugins/i18n'

export default {
  name: 'ConfirmDialog',
  data: () => ({
    dialog: false,
    dialogData: {},
  }),
  computed: {
    globalTexts: function() {
      return i18n.messages[i18n.locale].global
    },
  },
  methods: {
    show(inputData) {
      this.$nextTick(() => {
        this.dialog = true
        this.dialogData = inputData
      })
    },
    confirmAction1() {
      this.dialog = false
      this.dialogData.action = 1
      this.$emit('actionСonfirmed', this.dialogData)
    },
    confirmAction2() {
      this.dialog = false
      this.dialogData.action = 2
      this.$emit('actionСonfirmed', this.dialogData)
    },
    showDoc() {
      if (this.dialogData.previousDocument) {
        this.dialog = false
        router.push({ path: `/doczn/${this.dialogData.previousDocument}` })
      }
    },
    cancel() {
      this.textValue = ''
      this.dialog = false
    },
    checkEsc(ev) {
      if (ev.keyCode === 27) {
        this.dialog = false
        this.textValue = ''
      }
    },
  },
}
</script>

<style scoped lang="scss">
@import '../_scss/mixins';

.documet-link {
  text-decoration: underline;
  color: rgb(163, 166, 204);
}
.documet-link:hover {
  background: rgb(102, 80, 80);
}
</style>
